import { Button } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Alert from "../../components/atoms/alert";
import MainLayout from "../../components/layouts/mainLayout";
import { AppContext } from "../../context/AppContext";
import {
  getPrice,
  getUserData,
  updateStatus,
} from "../../firebase/firebaseutils";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const UserDetails = () => {
  const res = useContext(AppContext);
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState(0);
  const [rate, setRate] = useState("");
  const [total, setTotal] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [accomodation, setAccomodation] = useState(false);
  const [accomodationFee, setAccomodationFee] = useState(0);
  const [status, setStatus] = useState(false);
  const [gender, setGender] = useState(false);
  const [committeePreference, setCommitteePreference] = useState("");
  const [committeePreference2, setCommitteePreference2] = useState("");
  const [reference, setReference] = useState("");
  const [cnic, setCnic] = useState("");
  const [instituteName, setInstituteName] = useState("");
  const [instituteAddress, setInstituteAddress] = useState("");
  const [registeredInEvent, setRegisteredInEvent] = useState("");

  const [rejected, setRejected] = useState(false);
  const [approved, setApproved] = useState(false);

  //image state
  const [profilePic, setProfilePic] = useState("");
  const [depositSlip, setDepositSlip] = useState("");

  const [isTeams, setIsTeams] = useState(false);
  const [teams, setTeams] = useState(false);

  const [updatedSuccessfully, setUpdatedSuccessfully] = useState("start");

  const params = useParams();
  const user = res?.appLoadingStates?.user;
  const setLoading = res?.appLoadingStates?.setappLoader;
  // const loading = res?.appLoadingStates?.appLoader;

  const handleApprove = async () => {
    //update status to approved
    const status = "approved";
    setLoading(true);
    const res = await updateStatus(status, params.id);
    setLoading(false);
    setUpdatedSuccessfully(res);
    if (res) setApproved(true);
  };

  const handleReject = async () => {
    //update status to rejected
    const status = "rejected";
    setLoading(true);
    const res = await updateStatus(status, params.id);
    setLoading(false);
    setUpdatedSuccessfully(res);
    if (res) setRejected(true);
  };

  useEffect(() => {
    if (!user && res.appLoadingStates?.userStateFetched) navigate("/");
    const getUserInitialInfo = async () => {
      setLoading(true);
      const response = await getUserData(params.id);
      if (response.error) {
        console.log(response.error);
        setLoading(false);
      } else {
        setName(response?.firstName + " " + response?.lastName);
        setEmail(response?.email);
        setContact(response?.contact);
        setStatus(response?.status);
        setCommitteePreference(response?.committeePreference);
        setCommitteePreference2(response?.committeePreference2);
        setCnic(response?.cnic);
        setInstituteName(response?.instituteName);
        setInstituteAddress(response?.instituteAddress);
        setReference(response?.reference);
        setGender(response?.gender);
        setDepositSlip(response?.depositSlipUrl);
        setProfilePic(response?.imageUrl);
        setAccomodation(response?.accommodation);
        setRegisteredInEvent(response?.registeredInEvent);
        setIsTeams(response?.registeredInEvent === "individual" ? false : true);
        if (response?.teams) {
          setTeams(response?.teams);
        }

        getPrice().then((value) => {
          if (value && response?.registeredInEvent == "individual") {
            setRate(value?.individualDelegate);
            if (accomodation === 1) {
              setAccomodation(1);
              setAccomodationFee(value?.accommodationFee);
            }
            const total =
              1 * value.individualDelegate +
              (response?.accommodation === "Yes" ? value?.accommodationFee : 0);
            setTotal(total);
          } else if (value && response?.registeredInEvent === "team") {
            setRate(value?.delegateFee);
            setAccomodationFee(value?.accommodationFee);
            const total =
              response.teams?.length * value.delegateFee +
              response.teams.filter((team) => team.accommodation == "Yes")
                ?.length *
                value?.accommodationFee;

            setTotal(total);
          }
        });
        setLoading(false);
      }
    };

    if (user) {
      getUserInitialInfo();
    }
  }, [rejected, approved, user]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          minHeight: "100vh",
          width: "100vw",
          position: "relative",
          maxWidth: "1400px",
        }}
      >
        <MainLayout componentFlag="dashboard">
          <div style={{ width: "700px", minHeight: "500px" }}>
            <p>
              <strong>Name: </strong>
              <span>{name}</span>
            </p>
            <p>
              <strong>Email: </strong>
              <span>{email}</span>
            </p>
            <p>
              <strong>Contact: </strong>
              <span>{contact}</span>
            </p>
            <p>
              <strong>Cnic: </strong>
              <span>{cnic}</span>
            </p>

            <p>
              <strong>Commmittee Preference: </strong>
              <span>{committeePreference}</span>
            </p>
            <p>
              <strong>Commmittee Preference2: </strong>
              <span>{committeePreference2}</span>
            </p>
            <div>
              <p>
                <strong>Status: </strong>
                <span>{status}</span>
              </p>
              {status === "pending" ? (
                <div>
                  <Button variant="contained" onClick={handleReject}>
                    Reject
                  </Button>
                  <Button
                    variant="contained"
                    style={{ marginLeft: 20 }}
                    onClick={handleApprove}
                  >
                    Approve
                  </Button>

                  <a href={depositSlip} target="_blank">
                    <img
                      src={depositSlip}
                      alt="deposit-slip"
                      style={{
                        height: "450px",
                        width: "650px",
                        marginTop: "20px",
                      }}
                    />
                  </a>
                </div>
              ) : status === "approved" ? (
                <a href={depositSlip} target="_blank">
                  <img
                    src={depositSlip}
                    alt="deposit-slip"
                    style={{
                      height: "450px",
                      width: "650px",
                      marginTop: "20px",
                    }}
                  />
                </a>
              ) : (
                ""
              )}
            </div>
            <p>
              <strong>Registration Type: </strong>
              <span>{registeredInEvent || ""}</span>
            </p>
            <p>
              <strong>Institute Name: </strong>
              <span>{instituteName || ""}</span>
            </p>
            <p>
              <strong>Institute Address: </strong>
              <span>{instituteAddress || ""}</span>
            </p>
            <p>
              <strong>Reference: </strong>
              <span>{reference || "None"}</span>
            </p>
            <p>
              <strong>Accomodation: </strong>
              <span>{accomodation ? accomodation : "None"}</span>
            </p>
            <p>
              <strong>Total Price: </strong>
              <span>{total ? total : "None"}</span>
            </p>
            {profilePic ? (
              <div>
                <p>
                  <strong>Profile Picture: </strong>
                </p>
                <a href={profilePic} target="blank">
                  <div style={{ height: "300px", width: "400px" }}>
                    <img
                      src={profilePic}
                      style={{ height: "100%", width: "100%" }}
                      alt="profile-pic"
                    />
                  </div>
                </a>
              </div>
            ) : (
              <div>
                <p>
                  <strong>Profile Picture: </strong> <span>None </span>
                </p>
              </div>
            )}
            {isTeams ? (
              <TableContainer component={Paper} sx={{ marginTop: "30px" }}>
                <Table sx={{ minWidth: 1850 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell align="right">Email</TableCell>
                      <TableCell align="right">CNIC</TableCell>
                      <TableCell align="right">Contact</TableCell>
                      <TableCell align="right">Accomodation</TableCell>
                      <TableCell align="right">Gender</TableCell>
                      <TableCell align="right">Institute Name</TableCell>
                      <TableCell align="right">Institute Address</TableCell>
                      <TableCell align="right">Photograph</TableCell>
                      <TableCell align="right">Reference</TableCell>
                      <TableCell align="right">Committee Preference</TableCell>
                      <TableCell align="right">Committee Preference2</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {teams &&
                      teams?.map((row) => (
                        <TableRow
                          key={row.firstName}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row.firstName + "" + row.lastName}
                          </TableCell>
                          <TableCell align="right">{row.email}</TableCell>
                          <TableCell align="right">{row.cnic}</TableCell>
                          <TableCell align="right">{row.contact}</TableCell>
                          <TableCell align="right">
                            {row.accommodation}
                          </TableCell>
                          <TableCell align="right">{row.gender}</TableCell>
                          <TableCell align="right">
                            {row.instituteName}
                          </TableCell>
                          <TableCell align="right">
                            {row.instituteAddress}
                          </TableCell>
                          {/* {ADD PHOTOGRAPH} */}
                          <TableCell align="right">
                            <a href={row.image} target="blank">
                              <img
                                src={row.image}
                                style={{
                                  height: "50px",
                                  width: "50px",
                                  cursor: "pointer",
                                }}
                                alt="profile-picture"
                              />
                            </a>
                          </TableCell>
                          <TableCell align="right">
                            {row.reference ? row.reference : "None"}
                          </TableCell>
                          <TableCell align="right">
                            {row.committeePreference}
                          </TableCell>
                          <TableCell align="right">
                            {row.committeePreference2}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              ""
            )}
          </div>
          <div>
            {updatedSuccessfully === "empty" ? (
              ""
            ) : updatedSuccessfully === true ? (
              <Alert message="Updated Successfully" severity="success" />
            ) : updatedSuccessfully === false ? (
              <Alert message="Could not update" severity="error" />
            ) : (
              ""
            )}
          </div>
        </MainLayout>
        ;
      </div>
    </div>
  );
};

export default UserDetails;
